import { useDispatch, useSelector } from 'react-redux';
// import { openNotificationsPopup } from "redux/actions";

import {
  Stack,
  Slide,
  Dialog,
  Tooltip,
  useTheme,
  Typography,
  IconButton,
  DialogTitle,
  DialogContent,
  DialogActions,
  useMediaQuery,
  CircularProgress,
} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import NotificationsActiveRoundedIcon from '@mui/icons-material/NotificationsActiveRounded';

import NotificationContent from './NotificationContent';
import NotificationPermission from './NotificationPermission';
import useFCM from 'hooks/useFCM';
import { useState } from 'react';

const PushNotification = () => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const { fcmToken, loading, messages } = useFCM();

  // const { openNotifications } = useSelector((state) => state.notification);
  const { notificationPermissionPrompt: permission } = useSelector((state) => state.setting);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // const handleOpen = () => dispatch(openNotificationsPopup(true));
  // const handleClose = () => dispatch(openNotificationsPopup(false));

  return (
    <>
      <Tooltip title={permission !== 'granted' ? 'لطفا دسترسی اعلان ها را روشن نمایید' : 'اعلان ها'}>
        <IconButton
          size="medium"
          color="info"
          onClick={handleOpen}
          // disabled={permission === "denied"}
        >
          {loading ? <CircularProgress size={20} /> : <NotificationsActiveRoundedIcon fontSize="small" />}
        </IconButton>
      </Tooltip>
      <Dialog
        dir="rtl"
        fullWidth
        maxWidth="sm"
        scroll="paper"
        open={open}
        onClose={handleClose}
        fullScreen={isMobile}
        keepMounted
        aria-labelledby="push-notif-dialog-title"
        aria-describedby="push-notif-dialog-description"
        PaperProps={{
          sx: {
            borderRadius: 2,
            mt: { xs: 8, sm: 0 },
          },
        }}
      >
        <DialogTitle id="push-notif-dialog-title" sx={{ p: 2 }} component="div">
          <Stack direction="row" alignItems="center" columnGap={0.5}>
            <Typography flexGrow={1} variant="subtitle1" color="text.primary">
              اعلان ها
            </Typography>
            <IconButton
              size="small"
              color="error"
              aria-label="close"
              onClick={handleClose}
              sx={{ bgcolor: 'action.hover' }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Stack>
        </DialogTitle>
        <DialogContent
        // sx={{
        //   p: 2,
        //   rowGap: 0.5,
        //   minHeight: 200,
        //   display: "flex",
        //   pb: { xs: 15, sm: 2 },
        //   flexDirection: "column",
        //   justifyContent: "center",
        // }}
        >
          <Stack rowGap={1}>{open && <NotificationContent />}</Stack>
        </DialogContent>
        <DialogActions
          sx={{
            p: 2,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 10,
            rowGap: 0.5,
            display: 'flex',
            alignItems: 'stretch',
            justifyContent: 'center',
            flexDirection: 'column',
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            height: { xs: 80, sm: 'auto' },
            position: { xs: 'fixed', sm: 'unset' },
            bgcolor: { xs: '#fff', sm: 'transparent' },
            boxShadow: { xs: '0 -8px 16px -8px #00000022', sm: 'none' },
          }}
        >
          <Slide in unmountOnExit direction="up">
            <Stack direction="row-reverse" columnGap={1}>
              {open && <NotificationPermission />}
            </Stack>
          </Slide>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PushNotification;
